import React from 'react';
import StatCard from './StatCard';
import { Folder, DollarSign, CheckSquare, FileText } from '../../utils/icons';

interface QuickStatsProps {
  stats?: Array<{
    title: string;
    value: string | number;
    icon: React.ComponentType<any>;
    color?: 'primary' | 'blue' | 'green' | 'orange' | 'red';
    trend?: {
      value: number;
      label: string;
      isPositive: boolean;
    };
  }>;
}

const defaultStats = [
  {
    title: 'Active Cases',
    value: '24',
    icon: Folder,
    color: 'primary' as const,
    trend: {
      value: 12,
      label: 'vs last month',
      isPositive: true,
    },
  },
  {
    title: 'Monthly Revenue',
    value: 'MWK 55.1M',
    icon: DollarSign,
    color: 'green' as const,
    trend: {
      value: 8,
      label: 'vs last month',
      isPositive: true,
    },
  },
  {
    title: 'Open Tasks',
    value: '12',
    icon: CheckSquare,
    color: 'orange' as const,
    trend: {
      value: 5,
      label: 'vs last week',
      isPositive: false,
    },
  },
  {
    title: 'Documents',
    value: '156',
    icon: FileText,
    color: 'blue' as const,
    trend: {
      value: 23,
      label: 'vs last month',
      isPositive: true,
    },
  },
];

const QuickStats: React.FC<QuickStatsProps> = ({ stats = defaultStats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          title={stat.title}
          value={stat.value}
          icon={stat.icon as React.ComponentType<any>}
          color={stat.color}
          trend={stat.trend}
        />
      ))}
    </div>
  );
};

export default QuickStats;
